import React from "react";
import BarraSupDent from "../commons/BarraSupDent.jsx";
import firebasemanager from "../model/Firebase/FirebaseManager";
import Dent from "./Component/Dent.js";
import firebaseManager from "../model/Firebase/FirebaseManager";

class Confirm extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super(props);
    this.getdentSelected = this.getdentSelected.bind(this);
    this.chargePriceDentSelect = this.chargePriceDentSelect.bind(this);
  }
  getdentSelected = () => {
    firebasemanager.dentSelect();
  };

  handlePrice(e) {
    sessionStorage.setItem("dentPrice", e.target.value);
  }

  chargePriceDentSelect() {
    firebaseManager.confirmPriceDentSelected(
      this.successPriceCallback,
      this.failPriceCallback
    );
  }

  successPriceCallback = () => {
    window.location = "/dashboard";
  };

  failPriceCallback(error) {
    alert(error.mesagge);
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div className="text-center">
          <div className=" mt-5 pb-5 contenedor-confirm">
            <Dent />
            <div className="mt-2">
              <div className="form-group">
                <label htmlFor="daysSelected ml-1 mr-1">
                  Enter the price.
                </label>
                <input
                  placeholder="Example: 500"
                  name="price"
                  id="price"
                  onChange={this.handlePrice}
                  className="size d-block mx-auto"
                />
              </div>
            </div>
            <button
              onClick={this.chargePriceDentSelect}
              className="btn btn-secondary mx-auto mt-2"
            >
              CONFIRM
            </button>

            <br />
            <br />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Confirm;
